module.exports = __webpack_public_path__ + "static/media/gain_agility.d150405b.png";